

























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue';
import Table from '@/components/common/elements/Table.vue';
import { ActionButtons, StatusActions } from '@/services/hexabase/types';
import { TableParameters } from '@/constants/components/table';

@Component({
  components: { ActionButtonPanel, Table, SingleText }
})
export default class ActionButtonWithTablePanel extends Vue {
  @Prop({ default: '' })
  private listName?: string;
  @Prop({ default: '' })
  private label?: string;
  // ステータスアクション情報格納配列
  // execAllowActionsからさらにユーザIDや現登録データを判定してボタンの活性非活性を定義したもの
  @Prop({ default: [] })
  private statusButton?: Array<StatusActions>;
  // 現ステータスアクションと、現ステータスプレフィックスが定義されたデータ操作アクション
  @Prop({ default: [] })
  private execAllowActions?: Array<ActionButtons>;
  // Tableコンポーネント内で使用するパラメータ(カラム、データ、表示用のパラメータ)
  @Prop({ default: () => ({}) })
  private tableParameters?: TableParameters;
  // インフォメーションアイコンの設定
  @Prop({ default: '' })
  private displayInfomation!: string;

  /**
   * 子コンポーネントからEmitされる値を親コンポーネントに受け渡す
   * @module buttonAction
   * @param {string} type - 押下されたボタンのタイプ
   * @return {string} - 押下されたボタンのタイプ
   */
  @Emit('buttonActionRelay')
  private buttonActionRelay(type: string): string {
    return type;
  }

  /**
   * 表内ボタン押下で子コンポーネントからEmitされた値を親コンポーネントにEmitで返す
   * @module clickButtonRelay
   * @param response - 子コンポーネントのボタンイベント
   * @return response - 子コンポーネントの入力イベント
   */
  @Emit('clickButtonRelay')
  clickButtonRelay(response: any) {
    return response;
  }

  /**
   * 表内の入力で子コンポーネントからEmitされた値を親コンポーネントにEmitで返す
   * @module getDataRelay
   * @param response - 子コンポーネントの入力イベント
   * @return response - 子コンポーネントの入力イベント
   */
  @Emit('getDataRelay')
  getDataRelay(response: any) {
    return response;
  }

  /**
   * 親コンポーネントに押下した行を通知する
   * @module clickRowOpratiponRelay
   * @param  { [k: string]: string } - 対象行データ
   * @return { [k: string]: string } - 押下された行データ
   */
  @Emit('clickRowOpratiponRelay')
  public clickRowOpratiponRelay(clickRecord: { [k: string]: string }): { [k: string]: string } {
    return clickRecord;
  }
}
